module.exports = __webpack_public_path__ + "media/img/uploads/program-office-ccfe-798ec4abf27d677787d9e29490b75bec.jpg";